import { useState, useEffect } from 'react';
import { useInterval } from 'hooks';
import { Pad } from 'utils';

const PADDING_ZEROS = 2;
export const pad = (v: number) => Pad(v, PADDING_ZEROS);

const UPDATE = 250;
export interface Times {
  total: number;
  seconds: number;
  minutes: number;
  hours: number;
  days: number;
}
const calculateTime = (endTime: string): Times => {
  const t = Date.parse(endTime) - Date.parse(new Date().toISOString());
  const seconds = Math.max(0, Math.floor((t / 1000) % 60));
  const minutes = Math.max(0, Math.floor((t / 1000 / 60) % 60));
  const hours = Math.max(0, Math.floor((t / (1000 * 60 * 60)) % 24));
  const days = Math.max(0, Math.floor(t / (1000 * 60 * 60 * 24)));
  return {
    total: t,
    seconds,
    minutes,
    hours,
    days
  };
};

export const useCountdown = (endTime: string) => {
  const [time, setTime] = useState(calculateTime(endTime));
  const clear = useInterval(() => setTime(calculateTime(endTime)), UPDATE);

  useEffect(() => {
    if (time.total < 0) {
      clear();
    }
  }, [time, clear]);

  return time;
};
